import { Row } from "antd";
import styled, { css } from "styled-components";

export const StyledContentWrapper = styled.div<{ $isLoading: boolean }>`
  height: 100%;
  width: 100%;

  ${(props) =>
    props.$isLoading &&
    css`
      > div {
        z-index: 2000;
      }
    `}
`;

export const SidebarItemWithCounterWrapper = styled(Row)`
  width: 100%;

  span > sup {
    background: ${"#1890ff"} !important;
  }
`;
